import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { ListTable } from 'gnos-tables'
import _ from 'lodash'

import config from '../../../../../../../../../config'
import Tabs from '../../../../../../../../../components/Tabs'
import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import SecondaryNace from './components/SecondaryNace'
import SecondarySic from './components/SecondarySic'
import Trades from './components/Trades'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

@hocBlock(config.modules.report.key, { levelReload: true })
@injectIntl
export default class Activities extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        transformedData: PropTypes.object,
    }

    renderSummaryTables = () => {
        const { transformedData, id, intl } = this.props

        return _.map(_.get(transformedData, 'summaryTables', []), (table, index) => (
            <ListTable
                key={`summary-table-${id}-${index}`}
                id={`summary-table-${id}-${index}`}
                staticData={table}
                columnsDefinition={{
                    title: {
                        Cell: (title) => <span style={{ color: '#666' }} dangerouslySetInnerHTML={{ __html: _.get(title, 'text', '') }} ></span>,
                        width: 200,
                    },
                    top: {
                        columns: [
                            {
                                accessor: 'value',
                                Cell: ({ value }) => (
                                    <div>
                                        <span>{value}</span>
                                    </div>
                                ),
                            },
                            {
                                accessor: 'number',
                                Cell: ({ value }) => <span>{value}</span>,
                                width: 100,
                            },
                        ],
                    },
                }}
                texts={{
                    loading: intl.formatMessage({ id: 'global.loading' }),
                    noData: intl.formatMessage({ id: 'global.noData' }),
                    controlExpand: intl.formatMessage({ id: 'global.controlExpand' }),
                    controlMore: intl.formatMessage({ id: 'global.controlMore' }),
                    controlLess: intl.formatMessage({ id: 'global.controlLess' }),
                    controlAll: intl.formatMessage({ id: 'global.controlAll' }),
                    controlClose: intl.formatMessage({ id: 'global.controlClose' }),
                    controlFirst: intl.formatMessage({ id: 'global.controlFirst' }),
                }}
            />
        ))
    }

    render() {
        const {
            id,
            module,
            block,
            transformedData,
            level,
            intl: { formatMessage },
        } = this.props

        return (
            <div className={'block-activities'}>
                <div className={'summary-container'}>{this.renderSummaryTables()}</div>
                <div className={'activities-tabs-container'}>
                    <Tabs
                        level={level}
                        id={`activities-tabs-${id}`}
                        key={`activities-tabs-${id}`}
                        tabs={[
                            {
                                title: formatMessage({ id: `${LOCALE_PREFIX}.secondaryNace` }),
                                content: (
                                    <SecondaryNace
                                        id={id}
                                        tableData={_.get(transformedData, 'secondaryNace.secondaryNaceTable', {})}
                                        translates={{
                                            activitiesTitle: formatMessage({ id: `${LOCALE_PREFIX}.activitiesTitle` }),
                                        }}
                                    />
                                ),
                                subtitle: formatMessage({ id: `${LOCALE_PREFIX}.activities` }),
                                counter: {
                                    left: !_.isNil(_.get(transformedData, 'counts.secondaryNACECount'))
                                        ? transformedData.counts.secondaryNACECount
                                        : 0,
                                },
                            },
                            {
                                title: formatMessage({ id: `${LOCALE_PREFIX}.secondarySic` }),
                                content: (
                                    <SecondarySic
                                        id={id}
                                        tableData={_.get(transformedData, 'secondarySic.secondarySicTable', {})}
                                        translates={{
                                            activitiesTitle: formatMessage({ id: `${LOCALE_PREFIX}.activitiesTitle` }),
                                        }}
                                    />
                                ),
                                subtitle: formatMessage({ id: `${LOCALE_PREFIX}.activities` }),
                                counter: {
                                    left: !_.isNil(_.get(transformedData, 'counts.secondarySICCount'))
                                        ? transformedData.counts.secondarySICCount
                                        : 0,
                                },
                            },
                            {
                                title: formatMessage({ id: `${LOCALE_PREFIX}.trades` }),
                                content: (
                                    <Trades
                                        module={module}
                                        block={block}
                                        entId={id}
                                        level={level}
                                        translates={{
                                            activities: formatMessage({ id: `${LOCALE_PREFIX}.activities` }),
                                            tradeName: formatMessage({ id: `${LOCALE_PREFIX}.tradeName` }),
                                            tradeType: formatMessage({ id: `${LOCALE_PREFIX}.tradeType` }),
                                            durationFrom: formatMessage({ id: `${LOCALE_PREFIX}.durationFrom` }),
                                            durationTo: formatMessage({ id: `${LOCALE_PREFIX}.durationTo` }),
                                            page: formatMessage({ id: `${LOCALE_PREFIX}.page` }),
                                            from: formatMessage({ id: `${LOCALE_PREFIX}.from` }),
                                            rowShow: formatMessage({ id: `${LOCALE_PREFIX}.rowShow` }),
                                            rowCount: formatMessage({ id: `${LOCALE_PREFIX}.rowCount` }),
                                            suspension: formatMessage({ id: `${LOCALE_PREFIX}.suspension` }),
                                        }}
                                    />
                                ),
                                counter: {
                                    left: !_.isNil(_.get(transformedData, 'counts.activeTradesCount'))
                                        ? transformedData.counts.activeTradesCount
                                        : 0,
                                    right: !_.isNil(_.get(transformedData, 'counts.totalTradesCount'))
                                        ? transformedData.counts.totalTradesCount
                                        : 0,
                                },
                            },
                        ]}
                    />
                </div>
            </div>
        )
    }
}
